import styled from 'styled-components';

import ListItemMui from '@material-ui/core/ListItem';

export const Container = styled.div`
  .navigation-text {
    text-align: center;
    color: #8e8e8e;
    margin-bottom: 10px;
  }

  .MuiList-root {
    margin: 0px 20px;
  }

  .MuiListItem-root {
    background-color: #cbcbcb;
    color: #fff;
    border-radius: 3.76284px;

    & + .MuiListItem-root {
      margin-top: 20px;
    }
  }

  .MuiListItemIcon-root {
    svg,
    span {
      font-size: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;

      :before {
        font-size: 1.5rem; // icon-infusion
      }
    }
  }

  #clickhemofilia-logo {
    width: 37%;
    position: absolute;
    bottom: 40px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    display: block;
  }

  @media (max-height: 590px) {
    #clickhemofilia-logo {
      display: none;
    }
  }
`;

export const ListItem = styled(ListItemMui)`
  background-color: ${(props) =>
    props.selected ? '#0384AC' : '#cbcbcb'} !important;
`;
